// @ts-nocheck
/**
 * Configurador de Cristales Simple
 * Sistema limpio usando JSON config y API de Shopify para modificar precios
 */

class LensConfiguratorSimple {
  constructor(options = {}) {
    this.productId = options.productId;
    // El precio base se obtendrá dinámicamente del producto
    this.basePrice = 0; // Se inicializará después de detectar el precio del producto
    this.originalPrice = 0; // Precio original del producto antes de configuración
    this.currency = options.currency || 'EUR';
    // Preferir las traducciones pasadas en options, pero si no existen,
    // usar el objeto inyectado en window.themeTranslations.lens_configurator
    this.translations = (options.translations && Object.keys(options.translations).length)
      ? options.translations
      : ((window && window.themeTranslations && window.themeTranslations.lens_configurator) || {});
    
    this.currentStep = 0;
  this.steps = ['lens-type', 'progressive-sub', 'thickness', 'treatments', 'prescription', 'material'];
    this.stepInstances = []; // Instancias de los steps
    this.totalSteps = 6; // Valor por defecto, se recalculará dinámicamente
    this.configuration = {
      lensType: null,
      progressiveType: null, // Para sub-tipo de progresivos
      thickness: null, // Para grosor del cristal
      treatments: [],
      material: null,
      prescription: {}
    };
    
    this.lensPrice = 0;
    this.config = null;
    
    // Inicializar sistema multi-producto
    this.multiProductSystem = null;
  // Flag para indicar que la instancia terminó su init async y está lista
  this.isReady = false;
  this._addingToCart = false; // flag para evitar envíos simultáneos/dobles

  // Exponer la instancia globalmente para que otros scripts puedan detectarla
  try { window.lensConfiguratorSimple = this; } catch (e) {}
    
    this.init();
  }

  // (animation removed) simple step index tracking not required

  async init() {
    try {
      await this.loadConfiguration();
      await this.detectProductPrice();
      this.initializeElements();
      this.initializeSteps();
      this.renderCurrentStep();
      this.attachEventListeners();
      this.updatePriceDisplay();
      this.updateProgressBar();

      // Inicializar sistema multi-producto
      if (window.LensCartMultiProduct) {
        this.multiProductSystem = new window.LensCartMultiProduct(this);
      }
      // Marcar como listo y notificar a cualquier listener externo
      this.isReady = true;
      try {
        document.dispatchEvent(new CustomEvent('lens-configurator:ready', { detail: { instance: this } }));
      } catch (e) {}
    } catch (error) {
      console.error('Error initializing configurator:', error);
    }
  }

  // Inicializar steps modulares
  initializeSteps() {
    // Registrar las clases de steps pero no instanciarlas todavía.
    // Las instancias se crearán perezosamente cuando se muestren (renderCurrentStep).
    this.stepClasses = [
      window.LensTypeStep,
      window.ProgressiveStep,
      window.ThicknessStep,
      window.TreatmentsStep,
      window.PrescriptionStep,
      window.RecomendamosStep
    ];

    // Array para contener instancias creadas bajo demanda
    this.stepInstances = new Array(this.stepClasses.length).fill(null);
    this.totalSteps = this.stepClasses.length;
  }

  // Sistema de steps simplificado - sin modularidad compleja

  async detectProductPrice() {
    try {
      // Intentar múltiples métodos para detectar el precio base
      const methods = [
        () => this.extractPriceFromDOM(),
        () => this.getVariantPrice(),
        async () => await this.fetchProductPriceFromAPI()
      ];

      for (const method of methods) {
        try {
          const price = await method();
          if (price > 0) {
            this.basePrice = Math.round(price * 100); // convertir a centavos
            this.originalPrice = price;
            return;
          }
        } catch (e) {
          // Continuar con siguiente método
        }
      }

      // Fallback: precio por defecto
      this.basePrice = 10000; // €100 por defecto
      this.originalPrice = 100;

    } catch (error) {
      this.basePrice = 10000;
      this.originalPrice = 100;
    }
  }

  extractPriceFromDOM() {
    // Selectores comunes para precios en temas de Shopify
    const priceSelectors = [
      '.price__current',
      '.product__price .price__current',
      '.product-form__price .price__current',
      '[data-product-price]',
      '.price .money',
      '.product-price .money',
      '.product__price .money',
      '.price-item--regular',
      '.price--current'
    ];

    for (const selector of priceSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        const priceText = element.textContent || element.innerText || '';
        const price = this.parsePrice(priceText);
        if (price > 0) {
          return price;
        }
      }
    }

    return 0;
  }

  async fetchProductPriceFromAPI() {
    try {
      // Obtener handle del producto desde la URL o metadatos
      const productHandle = this.getProductHandle();
      if (!productHandle) return 0;

      const response = await fetch(`/products/${productHandle}.js`);
      const productData = await response.json();
      
      if (productData && productData.price) {
        // Shopify devuelve precios en centavos
        return productData.price / 100;
      }

      return 0;
    } catch (error) {
      return 0;
    }
  }

  getVariantPrice() {
    try {
      // Buscar información de variante en el DOM
      const variantSelectors = [
        'input[name="id"]:checked',
        'select[name="id"] option:selected',
        '[data-variant-id]',
        '.product-form__input input:checked'
      ];

      for (const selector of variantSelectors) {
        const element = document.querySelector(selector);
        if (element) {
          const price = parseFloat(element.getAttribute('data-price')) || 
                       parseFloat(element.getAttribute('data-variant-price'));
          if (price > 0) {
            return price / 100; // convertir de centavos a euros
          }
        }
      }

      return 0;
    } catch (error) {
      return 0;
    }
  }

  getProductHandle() {
    // Extraer handle del producto desde la URL
    const urlParts = window.location.pathname.split('/');
    const productIndex = urlParts.indexOf('products');
    if (productIndex !== -1 && urlParts[productIndex + 1]) {
      return urlParts[productIndex + 1];
    }

    // Alternativamente desde meta tags
    const handleMeta = document.querySelector('meta[property="product:handle"]');
    if (handleMeta) {
      return handleMeta.getAttribute('content');
    }

    return null;
  }

  parsePrice(priceText) {
    if (!priceText) return 0;
    
    // Limpiar texto y extraer números
    const cleaned = priceText.replace(/[^\d,.-]/g, '');
    const normalized = cleaned.replace(',', '.');
    const price = parseFloat(normalized);
    
    return isNaN(price) ? 0 : price;
  }

  async loadConfiguration() {
    // La configuración ahora se carga automáticamente por cada step individual
    // Esperar a que todos los steps terminen de cargar su configuración
    this.config = {};
    
    // Los steps individuales cargarán su configuración en sus constructores
    // Aquí solo esperamos a que estén listos
    await new Promise(resolve => setTimeout(resolve, 100)); // Pequeño delay para asegurar inicialización
  }

  // Configuración simplificada y estática - funciona sin dependencias externas

  /**
   * Carga los tipos de cristal dinámicamente desde productos de Shopify
   */
  initializeElements() {
    // Elementos de navegación - priorizar los del drawer si están disponibles
    this.prevBtn = document.getElementById('header-prev-drawer') || document.getElementById('header-prev');
    this.nextBtn = document.getElementById('header-next-drawer') || document.getElementById('header-next');
    this.applyBtn = document.getElementById('apply-config');
    
    // Elementos de progreso - priorizar los del drawer
    this.progressFill = document.getElementById('progress-fill-drawer') || document.getElementById('progress-fill');
    this.progressText = document.getElementById('progress-text-drawer') || document.getElementById('progress-text');
    
  this.sections = document.querySelectorAll('.config-section') || [];
    // Construir un mapa de secciones por data-step-key para desacoplar
    // el orden lógico (this.steps) del orden en el DOM
    this.sectionMap = {};
    if (this.sections && this.sections.length) {
      // Primero limpiar clases y recolectar keys explícitas
      this.sections.forEach((s, idx) => {
        s.classList.remove('lc-section', 'forward-enter', 'forward-enter-active', 'forward-exit', 'forward-exit-active', 'back-enter', 'back-enter-active', 'back-exit', 'back-exit-active');
        let key = s.getAttribute('data-step-key') || s.getAttribute('data-stepKey') || s.getAttribute('data-stepkey') || s.dataset.stepKey || null;
        if (key) {
          key = String(key).trim();
          this.sectionMap[key] = s;
        }
      });

      // Si no hay mapping explícito para todas las secciones, asignar por orden lógico this.steps
      if (Object.keys(this.sectionMap).length < this.sections.length) {
        // recorrer secciones en DOM y asignar keys faltantes desde this.steps en orden
        let stepIndex = 0;
        this.sections.forEach((s) => {
          // si esta sección ya tiene key explícita, saltarla en el orden
          const existingKey = Object.keys(this.sectionMap).find(k => this.sectionMap[k] === s);
          if (existingKey) return;

          // avanzar hasta encontrar una step key que no esté mapeada
          while (stepIndex < (this.steps || []).length && this.sectionMap[this.steps[stepIndex]]) {
            stepIndex++;
          }

          const assignKey = (this.steps && this.steps[stepIndex]) || null;
          if (assignKey) {
            this.sectionMap[assignKey] = s;
            stepIndex++;
          }
        });
      }

      // Establecer estado visible/hidden según la key actual
      const activeKey = (this.steps && this.steps[this.currentStep]) || null;
      Object.keys(this.sectionMap).forEach(k => {
        const s = this.sectionMap[k];
        if (!s) return;
        if (k === activeKey) {
          s.classList.add('active');
          s.classList.remove('hidden');
        } else {
          s.classList.add('hidden');
          s.classList.remove('active');
        }
      });
    }
    
    // Crear loader si no existe
    this.createLoader();
  }

  createLoader() {
    if (document.getElementById('step-loader')) return;
    
    const loader = document.createElement('div');
    loader.id = 'step-loader';
    loader.innerHTML = `
      <div class="loader-backdrop"></div>
      <div class="loader-content">
        <div class="spinner"></div>
        <span>Cargando...</span>
      </div>
    `;
    
    // Buscar el contenedor del drawer o del configurador
    const drawerContent = document.querySelector('.lens-drawer__content');
    const configuratorContainer = document.querySelector('.lens-configurator-simple');
    const container = drawerContent || configuratorContainer || document.body;

    // Append the loader to body so it can overlay above any blurred container
    // but remember the target container for applying the blur class.
    (document.body || document.documentElement).appendChild(loader);
  }

  // Obtener el contenedor activo donde debe aparecer el loader/blur.
  _getContainer() {
    // Preferir el contenido del drawer si existe
    const drawerContent = document.querySelector('.lens-drawer__content');
    if (drawerContent) return drawerContent;
    // Si no, intentar seleccionar el drawer en sí (por si el content aún no fue renderizado)
    const drawer = document.querySelector('.lens-drawer');
    if (drawer) return drawer;
    // Siguiente prioridad: el configurator embebido
    const configuratorContainer = document.querySelector('.lens-configurator-simple');
    if (configuratorContainer) return configuratorContainer;
    // Fallback: body
    return document.body;
  }

  // Helper para posicionar el loader sobre el rect del contenedor (drawer/configurator)
  _positionLoaderOver(container) {
    const loader = document.getElementById('step-loader');
    if (!loader || !container) return;
    try {
      const rect = container.getBoundingClientRect();
      loader.style.position = 'fixed';
      loader.style.left = `${rect.left}px`;
      loader.style.top = `${rect.top}px`;
      loader.style.width = `${rect.width}px`;
      loader.style.height = `${rect.height}px`;
      loader.style.display = 'flex';
      loader.style.pointerEvents = 'auto';
    } catch (e) {
      // fallback: mostrar a pantalla completa
      loader.style.position = 'fixed';
      loader.style.left = '0';
      loader.style.top = '0';
      loader.style.width = '100vw';
      loader.style.height = '100vh';
      loader.style.display = 'flex';
      loader.style.pointerEvents = 'auto';
    }
  }

  showLoader() {
    // Asegurar que el loader existe
    this.createLoader();
    const loader = document.getElementById('step-loader');
    const drawerContent = document.querySelector('.lens-drawer__content');
    const configuratorContainer = document.querySelector('.lens-configurator-simple');
    const container = this._getContainer();

    // Aplicar blur tanto al contenedor activo como al drawerContent si existe.
    try {
      if (container && container.classList) container.classList.add('drawer-loading-blur');
      if (drawerContent && drawerContent.classList) drawerContent.classList.add('drawer-loading-blur');
    } catch (e) {}

    if (loader) {
      console.log('[lens-configurator] showLoader', { time: Date.now(), container: (container && container.className) ? container.className : container });
      // Si hay un contenedor tipo drawer/configurator distinto del body,
      // añadimos el loader dentro del propio contenedor y lo posicionamos
      // absolute 0/0/100% para que quede contenido y no interfiera con scroll global.
      try {
        if (container !== document.body && container.appendChild) {
          if (loader.parentElement !== container) {
            container.appendChild(loader);
          }
          loader.style.position = 'absolute';
          loader.style.left = '0';
          loader.style.top = '0';
          loader.style.width = '100%';
          loader.style.height = '100%';
          loader.style.pointerEvents = 'auto';
        } else {
          // fallback: posicionar fixed sobre viewport
          this._positionLoaderOver(container);
          this._repositionHandler = () => this._positionLoaderOver(container);
          window.addEventListener('resize', this._repositionHandler);
          try {
            container.addEventListener && container.addEventListener('scroll', this._repositionHandler);
          } catch (e) {}
        }
      } catch (e) {
        this._positionLoaderOver(container);
      }

      // Forzar reflow para asegurar que la animación funcione
      loader.offsetHeight;
      loader.style.opacity = '1';
    }
  }

  hideLoader() {
    const loader = document.getElementById('step-loader');
    const drawerContent = document.querySelector('.lens-drawer__content');
    const configuratorContainer = document.querySelector('.lens-configurator-simple');
    const container = drawerContent || configuratorContainer || document.body;
    // Remover listeners de reposicionamiento inmediatamente para evitar side-effects
    try {
      if (this._repositionHandler) {
        window.removeEventListener('resize', this._repositionHandler);
        const drawerContent2 = document.querySelector('.lens-drawer__content');
        const configuratorContainer2 = document.querySelector('.lens-configurator-simple');
        const container2 = drawerContent2 || configuratorContainer2 || document.body;
        container2 && container2.removeEventListener && container2.removeEventListener('scroll', this._repositionHandler);
        // No eliminar la referencia todavía; la limpiaremos más abajo
      }
    } catch (e) {}

    if (loader) {
      console.log('[lens-configurator] hideLoader start', { time: Date.now() });
      // Permitir interacciones inmediatamente (evitar bloqueo persistente) durante fade-out
      loader.style.pointerEvents = 'none';
      loader.style.opacity = '0';
      // Ocultar completamente después de la transición
      setTimeout(() => {
        if (loader.style.opacity === '0') {
          loader.style.display = 'none';
          // Limpiar estilos posicionales para que el loader vuelva a su estado por defecto
          loader.style.position = '';
          loader.style.left = '';
          loader.style.top = '';
          loader.style.width = '';
          loader.style.height = '';
          loader.style.pointerEvents = 'none';
        }
      }, 150);
    }

    if (container && container.classList) {
      // Retirar la clase tras un pequeño delay para que la transición del loader termine
      setTimeout(() => {
        try { container.classList.remove('drawer-loading-blur'); } catch (e) {}
        try { drawerContent && drawerContent.classList.remove('drawer-loading-blur'); } catch (e) {}
      }, 120);
    }
    console.log('[lens-configurator] hideLoader scheduled cleanup', { time: Date.now() });

    // Limpiar referencia al handler (ya se removieron los listeners arriba)
    try {
      this._repositionHandler = null;
    } catch (e) {}
    
  }


  attachEventListeners() {
    // Event listeners para navegación con verificación null
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.previousStep());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextStep());
    }
    if (this.applyBtn) {
      this.applyBtn.addEventListener('click', () => this.applyConfiguration());
    }

    // Event listener para setup de productos addon
    const setupBtn = document.getElementById('setup-addons');
    if (setupBtn) {
      setupBtn.addEventListener('click', async () => {
        if (confirm('¿Crear productos addon en Shopify? Esta acción se hace una sola vez.')) {
          try {
            setupBtn.textContent = '⏳ Creando...';
            setupBtn.disabled = true;
            
            if (window.ShopifyAddonProductCreator) {
              const results = await window.ShopifyAddonProductCreator.run();
              alert(`✅ Productos creados: ${results.filter(r => r.success).length}/${results.length}`);
            } else {
              alert('❌ ShopifyAddonProductCreator no disponible');
            }
          } catch (error) {
            alert('❌ Error: ' + error.message);
          } finally {
            setupBtn.textContent = '🔧 Setup Addon Products';
            setupBtn.disabled = false;
          }
        }
      });
    }

    // Event listeners para selección de opciones - delegados a los steps
    document.addEventListener('click', (e) => {
      if (e.target && e.target instanceof Element && e.target.closest('.option-card')) {
        const card = e.target.closest('.option-card');
        const currentStepInstance = this.stepInstances[this.currentStep];
        if (currentStepInstance && currentStepInstance.handleOptionSelect) {
          currentStepInstance.handleOptionSelect(card);
        }
      }
    });

    // Event listeners para inputs de prescripción
    document.addEventListener('input', (e) => {
      if (e.target && e.target instanceof HTMLInputElement && e.target.matches('input[name^="od_"], input[name^="os_"]')) {
        this.updatePrescription();
        this.updatePriceDisplay();
      }
    });

    // Event listener para cambios de variante - reaplica la configuración si existe
    document.addEventListener('variant:changed', () => {
      if (this.configuration.lensType) {
        // Reaplica la configuración al nuevo formulario
        setTimeout(() => {
          this.applyConfigurationToProductForm();
        }, 100);
      }
    });
  }

  async renderCurrentStep() {
    console.log('[lens-configurator] renderCurrentStep start', { time: Date.now(), currentStep: this.currentStep });
    // Instanciar perezosamente el step si aún no existe
    if (!this.stepInstances[this.currentStep] && this.stepClasses && this.stepClasses[this.currentStep]) {
      try {
        const StepClass = this.stepClasses[this.currentStep];
        this.stepInstances[this.currentStep] = new StepClass(this);
      } catch (e) {
        console.error('Error instanciando step:', e);
      }
    }

    const currentStepInstance = this.stepInstances[this.currentStep];

    // Si el step tiene un método init (asíncrono) que realiza la carga de configuración,
    // ejecutarlo ahora para que la carga ocurra sólo cuando el step se necesita.
    if (currentStepInstance && typeof currentStepInstance.init === 'function') {
      try {
        // Permitimos que init sea async; no bloqueamos la UI excesivamente
        // pero esperamos a que la configuración esté lista antes de renderizar.
        this.showLoader();
        const maybePromise = currentStepInstance.init();
        if (maybePromise && typeof maybePromise.then === 'function') {
          await maybePromise;
        }
      } catch (e) {
        console.warn('Error inicializando step:', e);
      }
      // Nota: NO llamamos a hideLoader() aquí. Mantendremos el loader hasta
      // que terminen las animaciones de entrada del step (ver abajo).
    }

    // Verificar si el step debe saltarse
    if (currentStepInstance && currentStepInstance.shouldSkip()) {
      this.nextStep();
      return;
    }

  // Mostrar sección actual con animaciones (forward/back)
  // Devolver una Promise que se resuelve cuando las animaciones de entrada/salida acaben
  let animationPromiseResolve;
  const animationPromise = new Promise((resolve) => { animationPromiseResolve = resolve; });
    const currentKeyRaw = this.steps && this.steps[this.currentStep];
    const currentKey = currentKeyRaw ? String(currentKeyRaw).trim() : currentKeyRaw;

    // Intentar usar el mapa primero
    if (this.sectionMap && Object.keys(this.sectionMap).length > 0) {
      // Ocultar todas las secciones registradas en el mapa preparando animación
      const prevActive = Object.keys(this.sectionMap).find(k => this.sectionMap[k] && this.sectionMap[k].classList.contains('active'));
      const target = this.sectionMap[currentKey] || (currentKey ? document.querySelector(`[data-step-key="${currentKey}"]`) || document.querySelector(`[data-stepKey="${currentKey}"]`) || document.querySelector(`[data-stepkey="${currentKey}"]`) : null);

      // Determinar dirección de la animación: forward si el nuevo índice es mayor
      const newIndex = this.currentStep;
      const direction = (typeof this._lastStepIndex === 'number' && newIndex < this._lastStepIndex) ? 'back' : 'forward';

      // Limpiar clases de animación previas
      Object.keys(this.sectionMap).forEach(k => {
        const s = this.sectionMap[k];
        if (!s) return;
        s.classList.remove('forward-enter','forward-enter-active','forward-exit','forward-exit-active','back-enter','back-enter-active','back-exit','back-exit-active');
      });

      const prevSection = prevActive ? this.sectionMap[prevActive] : null;

  if (prevSection && prevSection !== target) {
        // Forzar estilos inline para que la sección pueda animarse aunque haya reglas globales
        prevSection.style.position = 'absolute';
        prevSection.style.top = '0';
        prevSection.style.left = '0';
        prevSection.style.right = '0';
        prevSection.style.zIndex = '2';
        // Aplicar clase de salida al previo (dirección + fade)
        prevSection.classList.add(`${direction}-exit`, 'fade-exit');
        // Forzar reflow para asegurar que la transición se aplique
        void prevSection.offsetWidth;
        prevSection.classList.add(`${direction}-exit-active`, 'fade-exit-active');
        // Al terminar la transición, ocultar y limpiar estilos
        const t = setTimeout(() => {
          prevSection.classList.remove('active', `${direction}-exit`, `${direction}-exit-active`, 'fade-exit', 'fade-exit-active');
          prevSection.classList.add('hidden');
          // limpiar estilos inline
          prevSection.style.position = '';
          prevSection.style.top = '';
          prevSection.style.left = '';
          prevSection.style.right = '';
          prevSection.style.zIndex = '';
          clearTimeout(t);
        }, 380);
      }

  if (target) {
        // Forzar estilos inline para entrante
        target.style.display = '';
        target.style.position = 'absolute';
        target.style.top = '0';
        target.style.left = '0';
        target.style.right = '0';
        target.style.zIndex = '1';
        // Preparar la sección entrante (dirección + fade)
        target.classList.remove('hidden');
        target.classList.add(`${direction}-enter`, 'fade-enter');
        // Forzar reflow
        void target.offsetWidth;
        target.classList.add(`${direction}-enter-active`, 'fade-enter-active');
        // Tras la animación, dejarla activa y limpiar estilos
        const t2 = setTimeout(() => {
          target.classList.remove(`${direction}-enter`, `${direction}-enter-active`, 'fade-enter', 'fade-enter-active');
          target.classList.add('active');
          // limpiar estilos inline
          target.style.position = '';
          target.style.top = '';
          target.style.left = '';
          target.style.right = '';
          target.style.zIndex = '';
          clearTimeout(t2);
        }, 380);
        // Resolver la promesa tras la animación entrante
        setTimeout(() => animationPromiseResolve(), 400);
      } else if (this.sections && this.sections.length > 0) {
        // Fallback por índice sin mapa
        this.sections.forEach((section, idx) => {
          if (idx === this.currentStep) {
            section.classList.remove('hidden');
            section.classList.add(`${direction}-enter`);
            void section.offsetWidth;
            section.classList.add(`${direction}-enter-active`);
            const t3 = setTimeout(() => {
              section.classList.remove(`${direction}-enter`, `${direction}-enter-active`,'fade-enter','fade-enter-active');
                section.classList.add('active');
              clearTimeout(t3);
            }, 380);
            setTimeout(() => animationPromiseResolve(), 400);
          } else {
            section.classList.remove('active');
            section.classList.add('hidden');
          }
        });
      }

      // Guardar índice para próxima navegación
      this._lastStepIndex = this.currentStep;
      // Si no hubo target/animated sections resolver inmediatamente
      setTimeout(() => {
        // En caso de que no se haya resuelto ya
        animationPromiseResolve && animationPromiseResolve();
      }, 450);
    } else if (this.sections && this.sections.length > 0) {
      // Fallback: orden por índice
      this.sections.forEach((section, idx) => {
        if (idx === this.currentStep) {
          section.classList.add('active');
          section.classList.remove('hidden');
        } else {
          section.classList.remove('active');
          section.classList.add('hidden');
        }
      });
  }

    // Renderizar el step actual usando la instancia modular antes de animar
    let renderPromise = null;
    if (currentStepInstance && typeof currentStepInstance.render === 'function') {
      try {
        const maybe = currentStepInstance.render();
        if (maybe && typeof maybe.then === 'function') {
          renderPromise = maybe;
        }
      } catch (e) {
        console.warn('⚠️ Error renderizando step:', e);
      }
    }

    this.updateNavigation();
    this.updateDrawerFooter();

    // Esperar a que las animaciones terminen (resuelve animationPromise)
    try {
      await animationPromise;
    } catch (e) {
      // no-op
    }

    // Después de la animación, asegurarnos de que el contenido del step está listo
    const readinessPromises = [];
    // Si render devolvió una promesa, esperarla
    if (renderPromise) readinessPromises.push(renderPromise);
    // Si el step expone whenReady(), usarla
    if (currentStepInstance && typeof currentStepInstance.whenReady === 'function') {
      try {
        const maybeReady = currentStepInstance.whenReady();
        if (maybeReady && typeof maybeReady.then === 'function') readinessPromises.push(maybeReady);
      } catch (e) {}
    }
    // Esperar que las imágenes dentro del target estén cargadas (si hay target)
    try {
      const imgs = target ? Array.from(target.querySelectorAll('img')) : [];
      imgs.forEach(img => {
        if (!img.complete) {
          readinessPromises.push(new Promise(resolve => {
            const onFinish = () => { img.removeEventListener('load', onFinish); img.removeEventListener('error', onFinish); resolve(); };
            img.addEventListener('load', onFinish);
            img.addEventListener('error', onFinish);
          }));
        }
      });
    } catch (e) {}

    // Esperar todas las promesas con un timeout de seguridad
    if (readinessPromises.length) {
      try {
        await Promise.race([
          Promise.all(readinessPromises),
          new Promise((resolve) => setTimeout(resolve, 2000)) // timeout 2s
        ]);
      } catch (e) {
        // no-op
      }
    }

    // Ocultar loader sólo cuando todo esté listo
    try { this.hideLoader(); } catch (e) {}
    return;
  }

  updatePrescription() {
    const fields = ['od_sphere', 'od_cylinder', 'od_axis', 'od_addition', 'os_sphere', 'os_cylinder', 'os_axis', 'os_addition'];
    const prescription = {};
    
    fields.forEach(field => {
      const input = document.querySelector(`input[name="${field}"]`);
      if (input && input instanceof HTMLInputElement && input.value) {
        prescription[field] = parseFloat(input.value) || 0;
      }
    });
    
    this.configuration.prescription = prescription;
  }

  calculatePrice() {
    if (!this.config) return 0;
    
    let totalPrice = 0;
    
    // Precio base del tipo de cristal
    if (this.configuration.lensType && this.config.lensTypes[this.configuration.lensType]) {
      totalPrice += this.config.lensTypes[this.configuration.lensType].price || this.config.lensTypes[this.configuration.lensType].basePrice || 0;
    }
    
    // Precio del material
    if (this.configuration.material && this.config.materials[this.configuration.material]) {
      totalPrice += this.config.materials[this.configuration.material].price || this.config.materials[this.configuration.material].priceModifier || 0;
    }
    
    // Precios de tratamientos
    if (Array.isArray(this.configuration.treatments)) {
      this.configuration.treatments.forEach(treatmentKey => {
        if (this.config.treatments[treatmentKey]) {
          totalPrice += this.config.treatments[treatmentKey].price || 0;
        }
      });
    }

    // Precio de sub-tipo de progresivos (si aplica)
    try {
      const progSel = this.configuration && this.configuration.progressiveType;
      if (progSel && this.config && this.config.progressiveTypes) {
        const selections = Array.isArray(progSel) ? progSel : [progSel];
        selections.forEach(k => {
          const p = this.config.progressiveTypes[k];
          if (p && (p.price || p.basePrice)) {
            totalPrice += p.price || p.basePrice || 0;
          }
        });
      }
    } catch (e) {}

    // Precio por grosor (thickness) si existe
    try {
      const tKey = this.configuration && this.configuration.thickness;
      if (tKey && this.config && this.config.thickness && this.config.thickness[tKey]) {
        const tInfo = this.config.thickness[tKey];
        totalPrice += tInfo.price || tInfo.priceModifier || 0;
      }
    } catch (e) {}
    
    this.lensPrice = totalPrice;
    return totalPrice;
  }

  updatePriceDisplay() {
    const totalPrice = this.basePrice + (this.lensPrice * 100); // Shopify usa centavos
    
    if (this.lensPriceEl) {
      this.lensPriceEl.textContent = this.formatPrice(this.lensPrice);
    }
    if (this.totalPriceEl) {
      this.totalPriceEl.textContent = this.formatPrice(totalPrice / 100);
    }
    
    // Mostrar precio base detectado
    const basePriceEl = document.getElementById('base-price');
    if (basePriceEl) {
      basePriceEl.textContent = this.formatPrice(this.basePrice / 100);
    }
    
    // Mostrar/ocultar precio de cristales
    if (this.lensPriceItem) {
      this.lensPriceItem.style.display = this.lensPrice > 0 ? 'flex' : 'none';
    }

    // Actualizar footer del drawer si está disponible
    this.updateDrawerFooter();
    
  }

  updateNavigation() {
    const isLastStep = this.currentStep === this.steps.length - 1;
    
    if (this.prevBtn && this.prevBtn instanceof HTMLButtonElement) {
      this.prevBtn.disabled = this.currentStep === 0;
    }
    
    if (this.nextBtn) {
      this.nextBtn.style.display = isLastStep ? 'none' : 'block';
    }
    if (this.applyBtn) {
      this.applyBtn.style.display = isLastStep ? 'block' : 'none';
    }
    
    // Actualizar progress bar
    this.updateProgressBar();
    
    // Mostrar setup button si no hay multi-producto configurado
    const setupBtn = document.getElementById('setup-addons');
    if (setupBtn && this.multiProductSystem) {
      const hasAddonIds = Object.values(this.multiProductSystem.ADDON_PRODUCT_IDS.lensTypes).some(id => id && id !== '49720018534713');
      setupBtn.style.display = !hasAddonIds ? 'inline-block' : 'none';
    }
  }

  updateProgressBar() {
    // Usar elementos del drawer si están disponibles, sino usar elementos del configurador
    const progressFill = this.progressFill || document.getElementById('progress-fill');
    const progressText = this.progressText || document.getElementById('progress-text');
    
    if (progressFill && progressText) {
      // Calcular pasos visibles dinámicamente
      const visibleSteps = this.getVisibleSteps();
      const currentVisibleStep = this.getCurrentVisibleStepNumber();
      
      // Calcular progreso basado en pasos visibles
      const progressPercentage = (currentVisibleStep / visibleSteps) * 100;
      
      // Actualizar barra de progreso
      progressFill.style.width = `${progressPercentage}%`;
      
      // Actualizar texto
      progressText.textContent = `Paso ${currentVisibleStep} de ${visibleSteps}`;
      
    }
  }
  
  getVisibleSteps() {
    // Computar dinámicamente según this.steps y reglas de visibilidad
    const stepKeys = this.steps || [];
    // Si el usuario eligió 'reading', simplificamos el flujo a sólo lens-type + material
    try {
      if (this.configuration && this.configuration.lensType === 'reading') {
        // Si 'material' (recomendados) existe en los pasos, contar ambos
        const hasMaterial = stepKeys.includes('material');
        return hasMaterial ? 2 : 1;
      }
    } catch (e) {}

    let count = 0;
    stepKeys.forEach(key => {
      if (key === 'progressive-sub') {
        if (this.configuration.lensType === 'progressive') count++;
      } else if (key === 'thickness') {
        const needsThickness = this.configuration.lensType === 'progressive' || this.configuration.lensType === 'monofocal';
        if (needsThickness) count++;
      } else {
        // Otros pasos se muestran siempre
        count++;
      }
    });
    return count;
  }

  getCurrentVisibleStepNumber() {
    // Determina cuál es la posición visible del paso actual (1-based)
    try {
      if (this.configuration && this.configuration.lensType === 'reading') {
        // Si estamos en el flujo reading, mapear índice a 1..2 según currentStep
        const steps = this.steps || [];
        const currentKey = steps[this.currentStep];
        // Paso 1 visible = 'lens-type', Paso 2 visible = 'material'
        if (!currentKey) return 1;
        if (currentKey === 'lens-type') return 1;
        if (currentKey === 'material') return 2;
        // Si estamos en un paso intermedio que no debería verse, encontrar su posición relativa
        const visible = [];
        if (steps.includes('lens-type')) visible.push('lens-type');
        if (steps.includes('material')) visible.push('material');
        const idx = visible.indexOf(currentKey);
        return idx === -1 ? 1 : idx + 1;
      }
    } catch (e) {}

    const visibleKeys = [];
    (this.steps || []).forEach(key => {
      if (key === 'progressive-sub') {
        if (this.configuration.lensType === 'progressive') visibleKeys.push(key);
      } else if (key === 'thickness') {
        const needsThickness = this.configuration.lensType === 'progressive' || this.configuration.lensType === 'monofocal';
        if (needsThickness) visibleKeys.push(key);
      } else {
        visibleKeys.push(key);
      }
    });

    const currentKey = this.steps && this.steps[this.currentStep];
    const index = visibleKeys.indexOf(currentKey);
    return index === -1 ? 1 : index + 1;
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.showLoader();

      setTimeout(() => {
        try {
            // Construir la lista de pasos visibles según la configuración actual
            let visibleKeys = [];
            if (this.configuration && this.configuration.lensType === 'reading') {
              // Para lectura, limitamos el flujo a lens-type y material (recomendados)
              visibleKeys = [];
              if ((this.steps || []).includes('lens-type')) visibleKeys.push('lens-type');
              if ((this.steps || []).includes('material')) visibleKeys.push('material');
            } else {
              visibleKeys = [];
              (this.steps || []).forEach(key => {
                if (key === 'progressive-sub') {
                  if (this.configuration.lensType === 'progressive') visibleKeys.push(key);
                } else if (key === 'thickness') {
                  const needsThickness = this.configuration.lensType === 'progressive' || this.configuration.lensType === 'monofocal';
                  if (needsThickness) visibleKeys.push(key);
                } else {
                  visibleKeys.push(key);
                }
              });
            }

          // Determinar el key actual en visibleKeys y retroceder al anterior visible
          const currentKey = this.steps && this.steps[this.currentStep];
          const currentVisibleIndex = visibleKeys.indexOf(currentKey);

          if (currentVisibleIndex > 0) {
            // Encontrar el key anterior visible y obtener su índice real en this.steps
            const prevVisibleKey = visibleKeys[currentVisibleIndex - 1];
            const prevIndex = this.steps.indexOf(prevVisibleKey);
            if (prevIndex !== -1) {
              this._lastStepIndex = (typeof this._lastStepIndex === 'number') ? this._lastStepIndex : this.currentStep + 1;
              this.currentStep = prevIndex;
              this.renderCurrentStep();
              return;
            }
          }

          // Fallback: retroceder uno por uno sin saltar más allá
          this.currentStep = Math.max(0, this.currentStep - 1);
          this._lastStepIndex = (typeof this._lastStepIndex === 'number') ? this._lastStepIndex : this.currentStep + 1;
          this.renderCurrentStep();
        } catch (e) {
          // En caso de error, usar comportamiento simple
          this.currentStep = Math.max(0, this.currentStep - 1);
          this.renderCurrentStep();
        }
      }, 50); // Reducido para respuesta más rápida
    }
  }

  nextStep() {
    
    if (this.currentStep < this.steps.length - 1) {
      this.showLoader();
      
      // Timeout mínimo para feedback visual inmediato
      setTimeout(() => {
        // Guardar índice previo para animación (hacia adelante)
        this._lastStepIndex = (typeof this._lastStepIndex === 'number') ? this._lastStepIndex : this.currentStep;
        this.currentStep++;
        // Renderizar el siguiente paso (renderCurrentStep se encargará de ocultar el loader
        // cuando las animaciones y la carga hayan finalizado)
        this.renderCurrentStep();
      }, 50); // Reducido para respuesta más rápida
    }
  }

  async applyConfiguration() {
    if (!this.configuration.lensType) {
      alert('Por favor selecciona al menos un tipo de cristal');
      return;
    }

    if (this.applyBtn) {
      this.applyBtn.classList.add('loading');
    }

    try {
      
      // Preparar configuración multi-producto
      await this.applyMultiProductSystem();
      
      // Mostrar confirmación
      const totalPrice = this.calculateTotalPrice();
      this.showAdvancedConfigurationComplete(totalPrice);
      
    } catch (error) {
      alert('Error al aplicar la configuración. Inténtalo de nuevo.');
    } finally {
      if (this.applyBtn) {
        this.applyBtn.classList.remove('loading');
      }
    }
  }

  async applyMultiProductSystem() {
    // Interceptar el formulario para añadir múltiples productos
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                       document.querySelector('form[action*="/cart/add"]');
    
    if (!productForm) {
      throw new Error('No se encontró formulario de producto');
    }

    // Preparar items para multi-producto
    const cartItems = this.buildCartItems();
    
    // Interceptar el submit del formulario
    this.interceptFormSubmit(productForm, cartItems);
    
    // Actualizar precio visual del producto principal (solo base)
    this.updateMainProductVisualPrice();
    
  }

  buildCartItems() {
    const mainVariantId = this.getVariantId();
    const groupId = `group-${Date.now()}`;
    const mainSKU = this.getProductSKU() || 'AINYMORE-MAIN';
    
    const items = [];
    
    // 1. Producto principal (solo precio base)
    const mainProperties = {
      '_p_groupId': groupId,
      '_p_productType': 'main',
      '_p_mainProductSKU': mainSKU,
      '_configuracion_label': 'Cristales personalizados'
    };

    // Añadir magnificación (si existe) a las propiedades del item principal
    try {
      if (this.configuration && this.configuration.magnification) {
        const raw = String(this.configuration.magnification).trim();
        const normalized = raw.startsWith('+') ? raw.slice(1) : raw;
        mainProperties['_magnification'] = String(this.configuration.magnification);
        // añadir una clave legible para que aparezca en el carrito/drawer y en Admin claramente
        mainProperties['Graduación'] = normalized;
      }
    } catch (e) {}

    items.push({
      id: mainVariantId,
      quantity: 1,
      properties: mainProperties
    });
    
    // 2. Addon: Tipo de cristal (si no es estándar)
    if (this.configuration.lensType && this.configuration.lensType !== 'single') {
      const lensConfig = this.config.lensTypes[this.configuration.lensType];
      if (lensConfig && lensConfig.basePrice > 0) {
        const lensProps = {
          '_p_groupId': groupId,
          '_p_productType': 'addon',
          '_p_mainProductSKU': mainSKU,
          '_tipo': lensConfig.name,
          '_para': 'Ambos ojos'
        };

        // Si hay magnification, añadirla también al addon de lente
        try {
          if (this.configuration && this.configuration.magnification) {
            const rawL = String(this.configuration.magnification).trim();
            const normalizedL = rawL.startsWith('+') ? rawL.slice(1) : rawL;
            lensProps['_magnification'] = String(this.configuration.magnification);
            lensProps['Graduación'] = normalizedL;
          }
        } catch (e) {}

        items.push({
          id: this.getAddonVariantId('lens', this.configuration.lensType),
          quantity: 1,
          properties: lensProps
        });
      }
    }
    
    // 3. Addon: Material (si no es estándar)
    if (this.configuration.material && this.configuration.material !== 'standard') {
      const materialConfig = this.config.materials[this.configuration.material];
      if (materialConfig && materialConfig.priceModifier > 0) {
        items.push({
          id: this.getAddonVariantId('material', this.configuration.material),
          quantity: 1,
          properties: {
            '_p_groupId': groupId,
            '_p_productType': 'addon',
            '_p_mainProductSKU': mainSKU,
            '_material': materialConfig.name,
            '_para': 'Ambos ojos'
          }
        });
      }
    }
    
    // 4. Addons: Tratamientos
    if (Array.isArray(this.configuration.treatments)) {
      this.configuration.treatments.forEach(treatmentKey => {
        const treatmentConfig = this.config.treatments[treatmentKey];
        if (treatmentConfig && treatmentConfig.price > 0) {
          // Construir propiedades del tratamiento y añadir metadata común
          const treatProps = Object.assign({}, {
            '_p_groupId': groupId,
            '_p_productType': 'addon',
            '_p_mainProductSKU': mainSKU,
            '_tratamiento': treatmentConfig.name,
            '_para': 'Ambos ojos'
          }, {
            '_configuracion_lentes': 'true',
            '_configuracion_completa': (this.buildDetailedConfigurationProperties && this.buildDetailedConfigurationProperties()['__configuracion_completa']) ? this.buildDetailedConfigurationProperties()['_configuracion_completa'] : ''
          });

          // Si el tratamiento es photocromatic y hay color seleccionado, persistir la propiedad
          try {
            if (treatmentKey === 'photocromatic' && this.configuration && this.configuration.photocromatic_color) {
              treatProps['_photocromatic_color'] = String(this.configuration.photocromatic_color);
            }
          } catch (e) {}

          items.push({
            id: this.getAddonVariantId('treatment', treatmentKey),
            quantity: 1,
            properties: treatProps
          });
        }
      });
    }

    // Debug: volcar items antes de devolver si se activa el flag global
    try { if (typeof window !== 'undefined' && window.LENS_DEBUG) console.debug('[LENS DEBUG] buildCartItems ->', items); } catch (e) {}
    
    return items;
  }

  getAddonVariantId(type, key) {
    // IDs reales de productos addon en Shopify
    const ADDON_PRODUCT_IDS = {
      lensTypes: {
        progressive: '51962426196305', // Cristales Progresivos
        reading: '51968567640401',     // Cristales de Lectura  
        monofocal: '51968474448209',   // Cristales Monofocales
        single: '51968512950609'       // Sin Graduar
      },
      materials: {
        thin: null,          // Material Cristal Fino - CREAR
        ultra_thin: null,    // Material Cristal Ultra Fino - CREAR
        trivex: null         // Material Trivex - CREAR
      },
      treatments: {
        anti_reflection: null, // Tratamiento Anti-Reflejo - CREAR
        blue_filter: null,     // Filtro Luz Azul - CREAR
        uv_protection: null    // Protección UV 100% - CREAR
      }
    };
    
    // Buscar el ID correspondiente
    let variantId = null;
    
    if (type === 'lens' && ADDON_PRODUCT_IDS.lensTypes[key]) {
      variantId = ADDON_PRODUCT_IDS.lensTypes[key];
    } else if (type === 'material' && ADDON_PRODUCT_IDS.materials[key]) {
      variantId = ADDON_PRODUCT_IDS.materials[key];
    } else if (type === 'treatment' && ADDON_PRODUCT_IDS.treatments[key]) {
      variantId = ADDON_PRODUCT_IDS.treatments[key];
    }
    
    if (variantId) {
      return variantId;
    } else {
      // Usar producto principal como fallback temporal
      return this.getVariantId();
    }
  }

  interceptFormSubmit(form, cartItems) {
    // Remover listeners previos
  const newForm = form.cloneNode(true);
  try { newForm.dataset.lensIntercepted = 'true'; } catch (e) {}
    form.parentNode.replaceChild(newForm, form);
    
    // Añadir nuevo listener
    newForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (this._addingToCart) return; // ya está procesando un envío
      this._addingToCart = true;
      try {
        await this.addMultipleItemsToCart(cartItems);
        // Mostrar éxito
        alert('✅ Productos añadidos al carrito exitosamente!');
        // Disparar evento de carrito actualizado
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        alert('Error al añadir al carrito. Inténtalo de nuevo.');
      } finally {
        this._addingToCart = false;
      }
    });
    
  }

  async addMultipleItemsToCart(items) {
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      
      if (response.ok) {
        const result = await response.json();
        return result;
      } else {
        const error = await response.json();
        throw new Error(`Error ${response.status}: ${error.message || 'Unknown error'}`);
      }
      
    } catch (error) {
      throw error;
    }
  }

  /**
   * Añadir al carrito únicamente lo seleccionado en el primer step (lens-type).
   * Usa el mapeo de getAddonVariantId para resolver la variante correspondiente.
   */
  async handleAddToCart() {
    if (this._addingToCart) return; // Ya se está procesando un envío
    this._addingToCart = true;
    try {
      if (!this.configuration || !this.configuration.lensType) {
        alert('Por favor selecciona un tipo de lente antes de añadir al carrito.');
        return;
      }

      // Construir groupId para relacionar items del bundle
      const groupId = `group-${Date.now()}`;

      // Producto principal (montura)
      const mainVariantId = Number(this.getVariantId());
      if (!mainVariantId) {
        alert('No se pudo resolver la variante del producto principal.');
        return;
      }

      const mainSKU = this.getProductSKU ? (this.getProductSKU() || 'AINYMORE-MAIN') : 'AINYMORE-MAIN';

      const mainItem = {
        id: mainVariantId,
        quantity: 1,
        properties: {
          '_p_groupId': groupId,
          '_p_productType': 'main',
          '_p_mainProductSKU': mainSKU,
          '_configuracion_label': 'Cristales personalizados'
        }
      };

      // Addon de tipo de lente
      const lensKey = this.configuration.lensType;
      const lensVariantId = this.getAddonVariantId('lens', lensKey);

      // Construir propiedades detalladas y agregarlas a los items
      const detailedProps = this.buildDetailedConfigurationProperties();
      // Marcar que este item fue configurado por el configurador
      detailedProps['_configuracion_lentes'] = 'true';
      // Precio total calculado (string) para mostrar visualmente en el carrito
      // (NO cambiaremos el total del carrito desde el override visual)
      try {
  const totalPrice = this.calculateTotalPrice();
  detailedProps['_precio_total_calculado'] = this.formatPrice(totalPrice);
        // Propiedad numérica para facilitar overrides y cálculos en cliente
        try { detailedProps['_precio_configurado'] = Number(Number(totalPrice).toFixed(2)); } catch (e) { detailedProps['_precio_configurado'] = totalPrice; }
      } catch (e) {
        // no-op
      }
      // Añadir nombre del grosor seleccionado si existe
      try {
        if (this.configuration && this.configuration.thickness && this.config && this.config.thickness && this.config.thickness[this.configuration.thickness]) {
          detailedProps['_grosor'] = this.config.thickness[this.configuration.thickness].name || this.configuration.thickness;
        } else {
          detailedProps['_grosor'] = '';
        }
      } catch (e) {
  detailedProps['_grosor'] = '';
      }

      // Añadir nombre del progresivo seleccionado si existe
      try {
        if (this.configuration && this.configuration.progressiveType && this.config && this.config.progressiveTypes) {
          // progressiveType puede ser string o array (multi-select)
          const prog = this.configuration.progressiveType;
          if (Array.isArray(prog)) {
            detailedProps['_progresivo'] = prog.map(k => (this.config.progressiveTypes[k] && this.config.progressiveTypes[k].name) || k).join(', ');
          } else {
            detailedProps['_progresivo'] = (this.config.progressiveTypes[prog] && this.config.progressiveTypes[prog].name) || prog;
          }
        } else {
          detailedProps['_progresivo'] = '';
        }
      } catch (e) {
        detailedProps['_progresivo'] = '';
      }

      // Añadir nombre(s) de los tratamientos seleccionados si existen
      try {
        const treatmentsSelection = this.configuration && this.configuration.treatments;
        if (treatmentsSelection) {
          const selections = Array.isArray(treatmentsSelection) ? treatmentsSelection : [treatmentsSelection];
          detailedProps['_tratamientos'] = selections.map(k => (this.config && this.config.treatments && this.config.treatments[k] && this.config.treatments[k].name) || k).join(', ');
        } else {
          detailedProps['_tratamientos'] = '';
        }
      } catch (e) {
        detailedProps['_tratamientos'] = '';
      }

      // Fusionar propiedades en el mainItem
      // Construir un desglose legible (tratamientos, progresivo, grosor) internamente
      // NOTA: no añadimos 'Desglose Configuración' a properties para evitar duplicados en la UI.
      try {
        const breakdownParts = [];
        // Tratamientos
        if (Array.isArray(this.configuration.treatments) && this.configuration.treatments.length > 0) {
          this.configuration.treatments.forEach(k => {
            const t = (this.config && this.config.treatments && this.config.treatments[k]) || null;
            if (t) breakdownParts.push(`${t.name} (${this.formatPrice(t.price)})`);
          });
        }
        // Progresivo
        if (this.configuration.progressiveType) {
          const progSel = Array.isArray(this.configuration.progressiveType) ? this.configuration.progressiveType : [this.configuration.progressiveType];
          progSel.forEach(k => {
            const p = (this.config && this.config.progressiveTypes && this.config.progressiveTypes[k]) || null;
            if (p) breakdownParts.push(`${p.name} (${this.formatPrice(p.price || p.basePrice || 0)})`);
          });
        }
        // Grosor
        if (this.configuration.thickness) {
          const tKey = this.configuration.thickness;
          const tinfo = (this.config && this.config.thickness && this.config.thickness[tKey]) || null;
          if (tinfo) breakdownParts.push(`${tinfo.name} (${this.formatPrice(tinfo.price || tinfo.priceModifier || 0)})`);
        }
        // aunque calculamos breakdownParts, no lo exponemos como propiedad para evitar duplicidades visuales
      } catch (e) {}

      mainItem.properties = Object.assign({}, mainItem.properties, detailedProps);

      // Añadir magnificación al mainItem si existe (para el flujo handleAddToCart)
      try {
        if (this.configuration && this.configuration.magnification) {
          const rawMag = String(this.configuration.magnification).trim();
          const normalizedMag = rawMag.startsWith('+') ? rawMag.slice(1) : rawMag;
          mainItem.properties['_magnification'] = String(this.configuration.magnification);
          mainItem.properties['Graduación'] = normalizedMag;
        }
      } catch (e) {}

      const items = [mainItem];

      if (lensVariantId && String(lensVariantId).trim() !== '') {
        const lensConfig = (this.config && this.config.lensTypes && this.config.lensTypes[lensKey]) || {};
        // Construir propiedades del addon de lente e incluir magnificación si existe
        try {
          const lensAddonProps = Object.assign({}, {
            '_p_groupId': groupId,
            '_p_productType': 'addon',
            '_p_mainProductSKU': mainSKU,
            '_tipo': lensConfig.name || String(lensKey),
            '_para': 'Ambos ojos'
          }, {
            // Añadir algunas propiedades generales para tracking
            '_configuracion_lentes': 'true',
            '_configuracion_completa': detailedProps['_configuracion_completa'] || ''
          });

          if (this.configuration && this.configuration.magnification) {
            const raw = String(this.configuration.magnification).trim();
            const normalized = raw.startsWith('+') ? raw.slice(1) : raw;
            lensAddonProps['_magnification'] = String(this.configuration.magnification);
            lensAddonProps['Graduación'] = normalized;
          }

          items.push({ id: Number(lensVariantId), quantity: 1, properties: lensAddonProps });
        } catch (e) {
          // Fallback simple
          items.push({
            id: Number(lensVariantId),
            quantity: 1,
            properties: Object.assign({}, {
              '_p_groupId': groupId,
              '_p_productType': 'addon',
              '_p_mainProductSKU': mainSKU,
              '_tipo': lensConfig.name || String(lensKey),
              '_para': 'Ambos ojos'
            }, {
              '_configuracion_lentes': 'true',
              '_configuracion_completa': detailedProps['_configuracion_completa'] || ''
            })
          });
        }
      }

      // Añadir item de grosor (thickness) si existe variante asociada
      try {
        const thicknessKey = this.configuration && this.configuration.thickness;
        if (thicknessKey && this.config && this.config.thickness && this.config.thickness[thicknessKey]) {
          const thicknessInfo = this.config.thickness[thicknessKey];
          // Preferir variant id si está disponible en la carga de productos
          const thicknessVariantId = (thicknessInfo.variants && thicknessInfo.variants.length > 0 && thicknessInfo.variants[0].id) ? thicknessInfo.variants[0].id : null;
          if (thicknessVariantId) {
            items.push({
              id: Number(thicknessVariantId),
              quantity: 1,
              properties: Object.assign({}, {
                  '_p_groupId': groupId,
                  '_p_productType': 'addon',
                  '_p_mainProductSKU': mainSKU,
                  '_grosor': thicknessInfo.name || thicknessKey
                }, {
                  '_configuracion_lentes': 'true',
                  '_configuracion_completa': detailedProps['_configuracion_completa'] || ''
                })
            });
          }
        }
      } catch (e) {
        // no-op
      }

      // Añadir item(s) para el progresivo si hay variant ids disponibles
      try {
        const progressiveSelection = this.configuration && this.configuration.progressiveType;
        if (progressiveSelection && this.config && this.config.progressiveTypes) {
          const selections = Array.isArray(progressiveSelection) ? progressiveSelection : [progressiveSelection];
          selections.forEach(key => {
            const progInfo = this.config.progressiveTypes[key];
            if (!progInfo) return;
            const progVariantId = (progInfo.variants && progInfo.variants.length > 0 && progInfo.variants[0].id) ? progInfo.variants[0].id : null;
            if (progVariantId) {
              items.push({
                id: Number(progVariantId),
                quantity: 1,
                properties: Object.assign({}, {
                  '_p_groupId': groupId,
                  '_p_productType': 'addon',
                  '_p_mainProductSKU': mainSKU,
                  '_progresivo': progInfo.name || key
                }, {
                  '_configuracion_lentes': 'true',
                  '_configuracion_completa': detailedProps['_configuracion_completa'] || ''
                })
              });
            }
          });
        }
      } catch (e) {
        // no-op
      }

      // Añadir item(s) para tratamientos si hay variant ids disponibles
      try {
        const treatmentsSelection = this.configuration && this.configuration.treatments;
        if (treatmentsSelection && this.config && this.config.treatments) {
          const selections = Array.isArray(treatmentsSelection) ? treatmentsSelection : [treatmentsSelection];
          selections.forEach(key => {
            const treatInfo = this.config.treatments[key];
            if (!treatInfo) return;
            const treatVariantId = (treatInfo.variants && treatInfo.variants.length > 0 && treatInfo.variants[0].id) ? treatInfo.variants[0].id : null;
            if (treatVariantId) {
              items.push({
                id: Number(treatVariantId),
                quantity: 1,
                properties: Object.assign({}, {
                  '_p_groupId': groupId,
                  '_p_productType': 'addon',
                  '_p_mainProductSKU': mainSKU,
                  '_tratamiento': treatInfo.name || key
                }, {
                  '_configuracion_lentes': 'true',
                  '_configuracion_completa': detailedProps['_configuracion_completa'] || ''
                })
              });
            }
          });
        }

            // Añadir item(s) para productos recomendados (RecomendadosStep)
            try {
              const recomendSelection = this.configuration && this.configuration.recomendado;
              if (recomendSelection && this.config && this.config.materials) {
                const selections = Array.isArray(recomendSelection) ? recomendSelection : [recomendSelection];
                for (const key of selections) {
                  const recInfo = this.config.materials[key];
                  if (!recInfo) continue;
                  // Preferir variant id si está disponible
                  let recVariantId = (recInfo.variants && recInfo.variants.length > 0 && recInfo.variants[0].id) ? recInfo.variants[0].id : null;
                  // Si no existe variant id, intentar resolver vía products/{handle}.js
                  if (!recVariantId && recInfo.handle) {
                    try {
                      const handle = String(recInfo.handle).trim();
                      const resp = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { 'Accept': 'application/json' } });
                      if (resp && resp.ok) {
                        const prod = await resp.json();
                        if (prod && prod.variants && prod.variants.length > 0 && prod.variants[0].id) {
                          recVariantId = prod.variants[0].id;
                        }
                      }
                    } catch (e) {
                      // fallback: no-op
                    }
                  }

                  if (recVariantId) {
                    // Añadir el recomendado como producto independiente (fuera de la sección 'Incluye')
                    items.push({
                      id: Number(recVariantId),
                      quantity: 1,
                      properties: Object.assign({}, {
                        // Marcar origen para diagnóstico/filtrado, pero NO agrupar con main
                        '_recomendado_from_configurator': 'true',
                        '_recomendado_name': recInfo.name || key
                      }, {
                        // Mantener metadata de configuración si procede
                        '_configuracion_completa': detailedProps['_configuracion_completa'] || ''
                      })
                    });
                  } else {
                    // Si no hay variant id incluso después del intento, añadimos como propiedad en mainItem (último recurso)
                    mainItem.properties = mainItem.properties || {};
                    if (!mainItem.properties['_recomendados_seleccionados']) mainItem.properties['_recomendados_seleccionados'] = '';
                    const existing = mainItem.properties['_recomendados_seleccionados'];
                    mainItem.properties['_recomendados_seleccionados'] = existing ? existing + ', ' + (recInfo.name || key) : (recInfo.name || key);
                  }
                }
              }
            } catch (e) {
              // no-op
            }
      } catch (e) {
        // no-op
      }

  // Asegurar que todos los items contienen las propiedades necesarias para agruparlos visualmente
  try {
    items.forEach((it, idx) => {
      it.properties = it.properties || {};
      // Si el item proviene de los recomendados, mantenerlo como línea independiente
      if (it.properties && it.properties['_recomendado_from_configurator']) {
        // No asignar groupId ni forzar tipo de producto; mantener solo metadata mínima
        if (!it.properties['_configuracion_lentes']) it.properties['_configuracion_lentes'] = 'true';
        return;
      }

      // No sobrescribir si ya existen
      if (!it.properties['_p_groupId']) it.properties['_p_groupId'] = groupId;
      if (!it.properties['_configuracion_lentes']) it.properties['_configuracion_lentes'] = 'true';
      // Marcar tipo si no existe
      if (!it.properties['_p_productType']) it.properties['_p_productType'] = (idx === 0) ? 'main' : 'addon';
    });
  } catch (e) {
    // no-op
  }

  // Enviar ambos items en una sola llamada
  await this.addMultipleItemsToCart(items);

      // Obtener estado actual del carrito y despachar eventos para que el mini-cart se actualice
      try {
        const resp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (resp && resp.ok) {
          const cart = await resp.json();
          const itemCount = cart.item_count || (cart.items ? cart.items.length : 0);

          // Evento moderno usado por componentes (ThemeEvents.cartUpdate -> 'cart:update')
          try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, data: { itemCount, source: 'lens-configurator' } } })); } catch (e) {}

          // Evento legacy que ya usan varios módulos en este theme
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, data: { itemCount, source: 'lens-configurator' } } })); } catch (e) {}
        } else {
          try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        }
      } catch (err) {
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
      }

      //alert('Productos añadidos al carrito correctamente.');
    } catch (error) {
      console.error('Error en handleAddToCart:', error);
      alert('Error al añadir el producto al carrito. Inténtalo de nuevo.');
      throw error;
    } finally {
      this._addingToCart = false;
    }
  }

  updateMainProductVisualPrice() {
    // Solo mostrar precio base en el producto principal
    // Los addons se mostrarán como items separados en el carrito
    const basePrice = this.basePrice / 100;
    const formattedPrice = this.formatPrice(basePrice);
    
    const priceSelectors = ['.price', '.product__price', '.product-form__price'];
    priceSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (!element.closest('#lens-configurator-simple')) {
          element.textContent = formattedPrice;
        }
      });
    });
  }

  calculateTotalPrice() {
    // Asegurarnos de tener lensPrice actualizado
    try { this.calculatePrice(); } catch (e) {}

    // this.basePrice está en centavos; this.lensPrice en euros
    const total = (Number(this.basePrice || 0) / 100) + Number(this.lensPrice || 0);
    return total;
  }

  applyAdvancedConfigurationToForm() {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                       document.querySelector('form[action*="/cart/add"]');
    
    if (!productForm) {
      return;
    }

    // Limpiar configuración previa
    this.clearConfigurationFromProductForm();

    // Crear propiedades detalladas de la configuración (solo internas)
    const properties = this.buildDetailedConfigurationProperties();
    
    // Añadir únicamente propiedades internas (prefijo _) como inputs ocultos
    Object.entries(properties).forEach(([key, value]) => {
      if (!key || typeof key !== 'string') return;
      if (!key.startsWith('_')) return; // evitar exponer etiquetas legibles
      if (value === null || value === undefined) return;
      const strVal = String(value);
      if (strVal.trim() === '') return;
      const input = document.createElement('input');
      input.type = 'hidden';
      // names like properties[_configuracion_completa]
      input.name = `properties[${key}]`;
      input.value = strVal;
      input.setAttribute('data-lens-config', 'true');
      productForm.appendChild(input);
    });

  }

  buildDetailedConfigurationProperties() {
    const properties = {};
    
    // 1. Tipo de gafas (interno)
    properties['_tipo_de_gafas'] = 'Gafas graduadas';
    
    // 2. Tipo de lentes (interno)
    if (this.configuration.lensType && this.config.lensTypes[this.configuration.lensType]) {
      const lensConfig = this.config.lensTypes[this.configuration.lensType];
      properties['_tipo_de_lentes'] = lensConfig.name;
    }
    
    // 3. Material (solo si no es estándar)
    if (this.configuration.material && 
        this.configuration.material !== 'standard' && 
        this.config.materials[this.configuration.material]) {
      const materialConfig = this.config.materials[this.configuration.material];
      properties['_material'] = materialConfig.name;
    }
    
    // 4. Tratamientos
    if (Array.isArray(this.configuration.treatments) && this.configuration.treatments.length > 0) {
      const treatmentNames = this.configuration.treatments
        .map(key => this.config.treatments[key] ? this.config.treatments[key].name : key)
        .filter(name => name);
      
      if (treatmentNames.length > 0) {
        properties['_tratamientos'] = treatmentNames.join(', ');
      }
    }
    
    // 5. Graduación (simulamos por ahora)
    if (Object.keys(this.configuration.prescription).length > 0) {
      // Si hay prescripción, mostrar resumen (interno)
      const prescFields = Object.keys(this.configuration.prescription);
      properties['_graduacion'] = `Configurada (${prescFields.length} valores)`;
    } else {
      properties['_graduacion'] = 'Hacerlo más tarde';
    }
    
    // 6. Información adicional para tracking interno
    properties['_configuracion_completa'] = JSON.stringify({
      lensType: this.configuration.lensType,
      material: this.configuration.material,
      treatments: this.configuration.treatments,
      prescription: this.configuration.prescription,
      basePrice_eur: Number((this.basePrice || 0) / 100),
      lensPrice_eur: Number(this.lensPrice || 0),
      totalPrice_eur: Number(((this.basePrice || 0) / 100) + (this.lensPrice || 0)),
      timestamp: new Date().toISOString()
    });

    // 7. Color fotocromático (si existe)
    try {
      if (this.configuration && this.configuration.photocromatic_color) {
        properties['_photocromatic_color'] = String(this.configuration.photocromatic_color);
      }
    } catch (e) {}
    
    return properties;
  }

  showAdvancedConfigurationComplete(totalPrice) {
    const notification = document.createElement('div');
    
    // Construir lista de productos que se añadirán
    const productList = [];
    productList.push(`<strong>• Producto principal:</strong> ${this.formatPrice(this.basePrice / 100)}`);
    
    if (this.configuration.lensType && this.configuration.lensType !== 'single' && this.config.lensTypes[this.configuration.lensType]) {
      const lensConfig = this.config.lensTypes[this.configuration.lensType];
      if (lensConfig.basePrice > 0) {
        productList.push(`<strong>• ${lensConfig.name}:</strong> ${this.formatPrice(lensConfig.basePrice)} (x2 ojos)`);
      }
    }
    
    if (this.configuration.material && this.configuration.material !== 'standard' && this.config.materials[this.configuration.material]) {
      const materialConfig = this.config.materials[this.configuration.material];
      if (materialConfig.priceModifier > 0) {
        productList.push(`<strong>• ${materialConfig.name}:</strong> ${this.formatPrice(materialConfig.priceModifier)} (x2 ojos)`);
      }
    }
    
    if (Array.isArray(this.configuration.treatments) && this.configuration.treatments.length > 0) {
      this.configuration.treatments.forEach(key => {
        const treatmentConfig = this.config.treatments[key];
        if (treatmentConfig && treatmentConfig.price > 0) {
          productList.push(`<strong>• ${treatmentConfig.name}:</strong> ${this.formatPrice(treatmentConfig.price)} (x2 ojos)`);
        }
      });
    }
    
    const itemCount = productList.length;
    
    notification.innerHTML = `
      <div class="notification-content">
        <h4>✅ Configuración Multi-Producto Lista</h4>
        <div style="margin: 12px 0; font-size: 0.9em; max-height: 150px; overflow-y: auto;">
          ${productList.join('<br>')}
        </div>
        <p><strong>Total estimado:</strong> ${this.formatPrice(totalPrice)}</p>
        <div style="margin: 12px 0; padding: 8px; background: rgba(255,255,255,0.15); border-radius: 4px; font-size: 0.85em;">
          <p><strong>🛒 Sistema Multi-Producto (como Miller&Marc)</strong></p>
          <p>✓ Se añadirán ${itemCount} productos al carrito</p>
          <p>✓ Cada componente será visible por separado</p>
          <p>✓ Precio total calculado automáticamente</p>
          <p><em>Haz clic en "Añadir al carrito" cuando estés listo</em></p>
        </div>
        <button onclick="this.parentElement.parentElement.remove()" style="margin-top: 10px; padding: 8px 15px; background: rgba(255,255,255,0.3); border: none; border-radius: 3px; color: white; cursor: pointer; font-weight: bold;">¡Perfecto!</button>
      </div>
    `;
    
    notification.style.cssText = `
      position: fixed; top: 20px; right: 20px; z-index: 1000;
      background: linear-gradient(135deg, #28a745, #20c997); color: white; padding: 18px; border-radius: 8px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.15); max-width: 350px; font-size: 14px;
      border: 2px solid rgba(255,255,255,0.2);
    `;
    
    document.body.appendChild(notification);
    
    // Auto-remove after 12 seconds (más tiempo para leer la lista)
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 12000);
  }

  /**
   * Determina si usar sistema multi-producto o precio único
   */
  shouldUseMultiProduct() {
    // Usar multi-producto si hay configuraciones significativas
    const hasAdvancedLens = this.configuration.lensType && this.configuration.lensType !== 'single';
    const hasAdvancedMaterial = this.configuration.material && this.configuration.material !== 'standard';
    const hasTreatments = this.configuration.treatments && this.configuration.treatments.length > 0;
    
    return hasAdvancedLens || hasAdvancedMaterial || hasTreatments;
  }

  /**
   * Aplica configuración usando sistema multi-producto
   */
  async applyMultiProductConfiguration() {
    try {
      
      // Obtener ID del producto principal
      const mainProductId = this.getVariantId();
      if (!mainProductId) {
        throw new Error('No se pudo obtener ID del producto principal');
      }
      
      // Construir items para el carrito
      const items = this.multiProductSystem.buildCartItems(mainProductId, 1);
      
      // En lugar de añadir al carrito, preparar el formulario del producto
      this.applyMultiProductToForm(items);
      
      // Actualizar precios visuales
      const totalPrice = this.basePrice + (this.lensPrice * 100);
      this.applyVisualPriceUpdate(totalPrice / 100);
      
    } catch (error) {
      throw error;
    }
  }

  /**
   * Aplica información multi-producto al formulario
   */
  applyMultiProductToForm(items) {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                       document.querySelector('form[action*="/cart/add"]');
    
    if (!productForm) {
      return;
    }
    
    // Limpiar configuración previa
    this.clearConfigurationFromProductForm();
    
    // Añadir información de la configuración multi-producto
    const configData = {
      type: 'multi-product',
      items: items,
      groupId: this.multiProductSystem.groupId,
      totalPrice: this.basePrice + (this.lensPrice * 100),
      configuration: this.configuration
    };
    
    // Crear input oculto con la configuración
    const configInput = document.createElement('input');
    configInput.type = 'hidden';
    configInput.name = 'properties[_lens_config]';
    configInput.value = JSON.stringify(configData);
    configInput.setAttribute('data-lens-config', 'true');
    productForm.appendChild(configInput);
    
    // Añadir properties legibles
    const readableConfig = this.multiProductSystem.buildConfigurationProperties();
    Object.keys(readableConfig).forEach(key => {
      const propInput = document.createElement('input');
      propInput.type = 'hidden';
      propInput.name = `properties[${key}]`;
      propInput.value = readableConfig[key];
      propInput.setAttribute('data-lens-config', 'true');
      productForm.appendChild(propInput);
    });
  }

  applyVisualPriceUpdate(newPrice) {
    // Actualizar precio visual en la página con más selectores
    const priceSelectors = [
      '.price',
      '.product__price',
      '.product-form__price',
      '[data-product-price]',
      '.price__regular',
      '.price-item',
      '.price-item--regular',
      '.product-price',
      '.current-price',
      '[data-price]',
      '.money',
      '.price .money'
    ];
    
    const formattedPrice = this.formatPrice(newPrice);
    
    let elementsUpdated = 0;
    
    priceSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        // Skip si es un elemento del configurador mismo
        if (element.closest('#lens-configurator-simple')) {
          return;
        }
        
        const originalText = element.textContent;
        element.textContent = formattedPrice;
        elementsUpdated++;
      });
    });
    
    // También actualizar atributos data-price si existen
    document.querySelectorAll('[data-price]').forEach(element => {
      if (!element.closest('#lens-configurator-simple')) {
        element.setAttribute('data-price', (newPrice * 100).toString()); // Shopify usa centavos
        elementsUpdated++;
      }
    });
    
    // Disparar eventos para notificar cambios
    document.dispatchEvent(new CustomEvent('price:updated', {
      detail: {
        newPrice: newPrice,
        formatted: formattedPrice
      }
    }));

    // Disparar evento para override de carrito
    document.dispatchEvent(new CustomEvent('lens:configured', {
      detail: {
        configuration: this.configuration,
        price: newPrice,
        originalPrice: this.basePrice / 100
      }
    }));
  }

  forceCompleteVisualUpdate(newPrice) {
    
    // Actualización más agresiva para desarrollo
    const allPossibleSelectors = [
      '.price',
      '.product__price',
      '.product-form__price',
      '[data-product-price]',
      '.price__regular',
      '.price-item',
      '.price-item--regular',
      '.product-price',
      '.current-price',
      '[data-price]',
      '.money',
      '.price .money',
      '.price-regular',
      '.price-current',
      '.variant-price',
      '.product-single__price',
      '#product-price',
      '.js-price',
      '[id*="price"]',
      '[class*="price"]'
    ];
    
    const formattedPrice = this.formatPrice(newPrice);
    let totalUpdated = 0;
    
    allPossibleSelectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          // Skip configurador elements
          if (element.closest('#lens-configurator-simple')) {
            return;
          }
          
          // Verificar si parece contener un precio
          const text = element.textContent;
          if (text && (text.includes('€') || text.includes('$') || /\d+[,.]?\d+/.test(text))) {
            element.textContent = formattedPrice;
            totalUpdated++;
          }
        });
      } catch (e) {
        // Ignore selector errors
      }
    });
    
    // Forzar actualización en el formulario de producto también
    const productForm = document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    if (productForm) {
      // Actualizar cualquier input oculto de precio
      const priceInputs = productForm.querySelectorAll('input[name*="price"], input[data-price]');
      priceInputs.forEach(input => {
        input.value = newPrice.toString();
        totalUpdated++;
      });
    }
    
    
    // Trigger más eventos para asegurar que otros scripts detecten el cambio
    setTimeout(() => {
      ['price:changed', 'product:price:updated', 'variant:changed'].forEach(eventName => {
        document.dispatchEvent(new CustomEvent(eventName, {
          detail: { price: newPrice, formatted: formattedPrice }
        }));
      });
    }, 100);
  }

  applyConfigurationToProductForm() {
    // Buscar el formulario de producto
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                       document.querySelector('form[action*="/cart/add"]');
    if (!productForm) {
      return;
    }

    // Remover inputs existentes de configuración de cristales
    const existingInputs = productForm.querySelectorAll('input[name^="properties["]');
    existingInputs.forEach(input => {
      if (input.name.includes('Tipo de Cristal') || 
          input.name.includes('Material') || 
          input.name.includes('Tratamientos') ||
          input.name.includes('Precio') ||
          input.name.includes('Configuración')) {
        input.remove();
      }
    });

    // Crear inputs ocultos SOLO con la configuración (sin información de precios separados)
    const config = this.buildFullConfiguration();
    
    const configInputs = [
      { name: 'properties[Tipo de Cristal]', value: config.lensTypeName || '' },
      { name: 'properties[Material]', value: config.materialName || '' },
      { name: 'properties[Tratamientos]', value: config.treatmentNames ? config.treatmentNames.join(', ') : '' },
      { name: 'properties[Configuración Completa]', value: this.getConfigurationSummary() }
    ];

    // Añadir prescripción si existe
    if (Object.keys(this.configuration.prescription).length > 0) {
      configInputs.push({
        name: 'properties[Prescripción]',
        value: JSON.stringify(this.configuration.prescription)
      });
    }

    // Crear e insertar los inputs
    configInputs.forEach(inputData => {
      if (inputData.value && inputData.value !== '') {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputData.name;
        input.value = inputData.value;
        input.setAttribute('data-lens-config', 'true');
        productForm.appendChild(input);
      }
    });

  }

  getConfigurationSummary() {
    const parts = [];
    
    if (this.configuration.lensType && this.config.lensTypes[this.configuration.lensType]) {
      parts.push(this.config.lensTypes[this.configuration.lensType].name);
    }
    
    if (this.configuration.material && this.config.materials[this.configuration.material]) {
      parts.push(this.config.materials[this.configuration.material].name);
    }
    
    if (Array.isArray(this.configuration.treatments) && this.configuration.treatments.length > 0) {
      const treatments = this.configuration.treatments.map(key => 
        this.config.treatments[key] ? this.config.treatments[key].name : key
      );
      parts.push(treatments.join(', '));
    }
    
    return parts.join(' - ');
  }

  showAppliedConfiguration(config, finalPrice) {
    // Aquí puedes mostrar un modal o notificación
    
    // Ejemplo de notificación simple
    const notification = document.createElement('div');
    notification.className = 'lens-config-notification';
    notification.innerHTML = `
      <div class="notification-content">
        <h4>✅ Configuración Aplicada y Servicio Añadido</h4>
        <p><strong>Precio gafas:</strong> ${this.formatPrice(this.basePrice / 100)}</p>
        <p><strong>Servicio cristales:</strong> +${this.formatPrice(this.lensPrice)}</p>
        <p><strong>Total:</strong> ${this.formatPrice(finalPrice)}</p>
        <div style="margin: 12px 0; padding: 8px; background: rgba(255,255,255,0.15); border-radius: 4px; font-size: 0.85em;">
          <p><strong>🎉 ¡Ya tienes el servicio de cristales en tu carrito!</strong></p>
          <p>✓ Configuración guardada</p>
          <p>✓ Servicio de cristales añadido</p>
          <p><em>Ahora solo añade las gafas con el botón "Añadir al carrito"</em></p>
        </div>
        <button onclick="this.parentElement.parentElement.remove()" style="margin-top: 10px; padding: 8px 15px; background: rgba(255,255,255,0.3); border: none; border-radius: 3px; color: white; cursor: pointer; font-weight: bold;">¡Perfecto!</button>
      </div>
    `;
    notification.style.cssText = `
      position: fixed; top: 20px; right: 20px; z-index: 1000;
      background: linear-gradient(135deg, #28a745, #20c997); color: white; padding: 18px; border-radius: 8px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.15); max-width: 320px; font-size: 14px;
      border: 2px solid rgba(255,255,255,0.2);
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 10000);
  }

  async addLensServiceToCart() {
    if (this.lensPrice <= 0) {
      return false;
    }

    try {
      
      // Obtener el ID de variante del producto actual para usar como base
      const variantId = this.getMainProductVariantId();
      if (!variantId) {
        return false;
      }

      // Crear configuración del servicio
      const config = this.buildFullConfiguration();
      const serviceData = {
        id: variantId,
        quantity: 1,
        properties: {
          '_es_servicio_cristales': 'true',
          '_precio_servicio': this.lensPrice.toFixed(2),
          '_producto': '🔬 Servicio de Cristales',
          '_para_gafas': this.getProductTitle(),
          '_tipo_de_cristal': config.lensTypeName || config.configuration.lensType || '',
          '_material': config.materialName || config.configuration.material || '',
          '_tratamientos': config.treatmentNames ? config.treatmentNames.join(', ') : '',
          '_precio_del_servicio': this.formatPrice(this.lensPrice),
          '_configuracion_serializada': JSON.stringify(config.configuration)
        }
      };

      // Añadir prescripción si existe
      if (Object.keys(this.configuration.prescription).length > 0) {
        serviceData.properties['_prescripcion_resumen'] = JSON.stringify(this.configuration.prescription).substring(0, 100);
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(serviceData)
      });

      if (response.ok) {
        const result = await response.json();
        
        // Disparar evento de carrito actualizado
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        return true;
      } else {
        const errorData = await response.json();
        return false;
      }
      
    } catch (error) {
      return false;
    }
  }

  getMainProductVariantId() {
    // Buscar el ID de variante en el formulario de producto
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (productForm) {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      if (variantIdInput && variantIdInput.value) {
        return variantIdInput.value;
      }
    }

    // Como fallback, usar el productId configurado
    if (this.productId) {
      return this.productId.toString();
    }

    return null;
  }

  getProductTitle() {
    // Intentar obtener el título del producto actual
    const titleSelectors = [
      '.product__title',
      '.product-title', 
      'h1.title',
      '[data-product-title]',
      'h1'
    ];

    for (const selector of titleSelectors) {
      const element = document.querySelector(selector);
      if (element && element.textContent) {
        return element.textContent.trim();
      }
    }

    return 'Gafas seleccionadas';
  }

  localReset() {
    // Reset configuration
    this.configuration = {
      lensType: null,
      material: null,
      treatments: [],
      prescription: {}
    };
    
    this.lensPrice = 0;
    this.currentStep = 0;
    
    // Reset UI
    const selectedCards = document.querySelectorAll('.option-card.selected');
    selectedCards.forEach(card => card.classList.remove('selected'));
    
    // Reset prescription inputs
    const prescriptionInputs = document.querySelectorAll('input[name^="od_"], input[name^="os_"]');
    prescriptionInputs.forEach(input => {
      if (input instanceof HTMLInputElement) {
        input.value = '';
      }
    });
    
    // Update displays
    this.updatePriceDisplay();
    this.renderCurrentStep();
  }

  buildFullConfiguration() {
    const config = {
      productId: this.productId,
      basePrice: this.basePrice,
      lensPrice: this.lensPrice,
      totalPrice: this.basePrice + (this.lensPrice * 100),
      configuration: { ...this.configuration },
      timestamp: new Date().toISOString()
    };

    // Agregar nombres legibles
    if (this.config) {
      if (config.configuration.lensType && this.config.lensTypes[config.configuration.lensType]) {
        config.lensTypeName = this.config.lensTypes[config.configuration.lensType].name;
      }
      
      if (config.configuration.material && this.config.materials[config.configuration.material]) {
        config.materialName = this.config.materials[config.configuration.material].name;
      }
      
      if (Array.isArray(config.configuration.treatments)) {
        config.treatmentNames = config.configuration.treatments.map(key => 
          this.config.treatments[key] ? this.config.treatments[key].name : key
        );
      }
    }

    return config;
  }

  formatPrice(price) {
    const numPrice = parseFloat(price) || 0;
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(numPrice);
  }

  updateSectionBudget(sectionKey, options) {
    const budgetElement = document.getElementById(`${sectionKey}-budget`);
    if (!budgetElement || !options) return;
    
    // Calcular el precio mínimo de las opciones
    let minPrice = Infinity;
    let maxPrice = 0;
    
    Object.values(options).forEach(option => {
      const price = option.price || option.basePrice || option.priceModifier || 0;
      if (price < minPrice) minPrice = price;
      if (price > maxPrice) maxPrice = price;
    });
    
    // Si todas las opciones son gratis
    if (minPrice === Infinity || minPrice === 0) {
      budgetElement.textContent = 'Incluido';
    } else if (minPrice === maxPrice) {
      // Si todas las opciones cuestan lo mismo
      budgetElement.textContent = this.formatPrice(minPrice);
    } else {
      // Rango de precios
      budgetElement.textContent = `Desde ${this.formatPrice(minPrice)}`;
    }
  }

  updateProductPriceDisplay(newPrice) {
    // Actualizar todos los elementos de precio del producto
    const priceElements = [
      '.price__current',
      '.price .price__current', 
      '.product__price .price__current',
      '[data-product-price]',
      '.product-form__price .price__current'
    ];

    priceElements.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.textContent = this.formatPrice(newPrice);
        element.setAttribute('data-original-price', element.getAttribute('data-original-price') || element.textContent);
      });
    });

  }

  showPriceUpdateNotification(newPrice) {
    const notification = document.createElement('div');
    notification.className = 'lens-price-update-notification';
    notification.innerHTML = `
      <div class="notification-content">
        <h4>✅ Precio Actualizado Dinámicamente</h4>
        <p><strong>Precio base detectado:</strong> ${this.formatPrice(this.basePrice / 100)}</p>
        <p><strong>Configuración cristales:</strong> +${this.formatPrice(this.lensPrice)}</p>
        <p><strong>Precio final:</strong> ${this.formatPrice(newPrice)}</p>
        <div style="margin: 12px 0; padding: 8px; background: rgba(255,255,255,0.15); border-radius: 4px; font-size: 0.85em;">
          <p><strong>� ¡Precio detectado automáticamente!</strong></p>
          <p>✓ El sistema detectó el precio base de este producto</p>
          <p>✓ Precio actualizado con tu configuración</p>
          <p><em>Añade al carrito cuando estés listo</em></p>
        </div>
        <button onclick="this.parentElement.parentElement.remove()" style="margin-top: 10px; padding: 8px 15px; background: rgba(255,255,255,0.3); border: none; border-radius: 3px; color: white; cursor: pointer; font-weight: bold;">Entendido</button>
      </div>
    `;
    notification.style.cssText = `
      position: fixed; top: 20px; right: 20px; z-index: 1000;
      background: linear-gradient(135deg, #28a745, #20c997); color: white; padding: 18px; border-radius: 8px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.15); max-width: 320px; font-size: 14px;
      border: 2px solid rgba(255,255,255,0.2);
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 8000);
  }

  showConfigurationComplete(config, totalPrice) {
    // Mostrar notificación de configuración completa (sin carrito dual)
    
    // Evento personalizado para indicar que la configuración está lista
    document.dispatchEvent(new CustomEvent('lensConfigurationReady', {
      detail: {
        configuration: this.configuration,
        basePrice: this.basePrice / 100,
        additionalPrice: this.lensPrice,
        totalPrice: totalPrice,
        ready: true
      }
    }));

    // Emit a lightweight compatibility event used by other scripts
    try {
      document.dispatchEvent(new CustomEvent('lens:configured', {
        detail: {
          configuration: this.configuration,
          basePrice: this.basePrice / 100,
          additionalPrice: this.lensPrice,
          totalPrice: totalPrice,
          ready: true
        }
      }));
    } catch (e) { /* ignore */ }
  }

  // Método para agregar al carrito con configuración
  async addToCart() {
    if (!this.configuration.lensType) {
      alert('Por favor configura los cristales primero');
      return;
    }

    const config = this.buildFullConfiguration();
    const cartData = {
      id: this.productId,
      quantity: 1,
      properties: {
        '_configuracion_lentes': 'true',
        '_tipo_de_cristal': config.lensTypeName || config.configuration.lensType,
        '_material': config.materialName || config.configuration.material,
        '_tratamientos': config.treatmentNames ? config.treatmentNames.join(', ') : '',
        '_precio_base': this.formatPrice(this.basePrice / 100),
        '_precio_cristales': this.formatPrice(this.lensPrice),
        // Compatibility: provide machine-friendly values
        '_precio_adicional_cristales': String(this.lensPrice),
        '_precio_total': this.formatPrice(config.totalPrice / 100),
        '_precio_total_calculado': this.formatPrice(config.totalPrice / 100),
        '_configuracion_serializada': JSON.stringify(config.configuration)
      }
    };

    if (Object.keys(this.configuration.prescription).length > 0) {
      cartData.properties['_prescripcion_resumen'] = JSON.stringify(this.configuration.prescription);
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      });

      if (response.ok) {
        // Disparar evento de carrito actualizado
        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Also emit lens-specific add event for compatibility with multi-product flow
        try {
          document.dispatchEvent(new CustomEvent('lens:cart:added', {
            detail: { cartData: cartData }
          }));
        } catch (e) { /* ignore */ }

        // Signal that configurator has produced a configuration (other scripts listen to this)
        try {
          document.dispatchEvent(new CustomEvent('lens:configured', {
            detail: { configuration: this.configuration, additionalPrice: this.lensPrice }
          }));
        } catch (e) { /* ignore */ }
      } else {
        throw new Error('Error adding to cart');
      }
    } catch (error) {
      alert('Error al agregar al carrito. Inténtalo de nuevo.');
    }
  }

  // Obtener configuración actual
  getCurrentConfiguration() {
    return this.buildFullConfiguration();
  }

  // Obtener el ID del variant actual del producto
  getVariantId() {
    // Buscar en el formulario de producto
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                       document.querySelector('form[action*="/cart/add"]');
    
    if (productForm) {
      // Buscar input de variant ID
      const variantInput = productForm.querySelector('input[name="id"]') ||
                          productForm.querySelector('input[name="variant_id"]') ||
                          productForm.querySelector('select[name="id"]');
      
      if (variantInput) {
        return variantInput.value;
      }
    }
    
    // Buscar en elementos con data attributes
    const variantElement = document.querySelector('[data-variant-id]') ||
                          document.querySelector('[data-product-variant-id]');
    
    if (variantElement) {
      return variantElement.dataset.variantId || variantElement.dataset.productVariantId;
    }
    
    // Buscar en la URL si contiene variant=
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) {
      return variantFromUrl;
    }
    
    // Buscar en variables globales de Shopify
    if (window.meta && window.meta.product && window.meta.product.variants) {
      const firstVariant = window.meta.product.variants[0];
      if (firstVariant && firstVariant.id) {
        return firstVariant.id.toString();
      }
    }
    
    return null;
  }

  updateDrawerFooter() {
    // Actualizar footer del drawer si está disponible
    if (window.lensDrawerManager && typeof window.lensDrawerManager.updateFooterSummary === 'function') {
      const summary = this.getFooterSummary();
      window.lensDrawerManager.updateFooterSummary(summary);
    }
  }

  getFooterSummary() {
    // Si tenemos steps modulares, usarlos para generar el resumen
    if (this.stepInstances.length > 0) {
      return this.getFooterSummaryModular();
    }

    // Fallback al método legacy
    return this.getFooterSummaryLegacy();
  }

  getFooterSummaryModular() {
    const summary = {
      basePrice: this.formatPrice(this.basePrice / 100),
      totalPrice: this.formatPrice((this.basePrice + (this.lensPrice * 100)) / 100),
      items: []
    };

    const normalized = { ...summary };

    const toCamelCase = (value = '') => {
      const str = String(value).trim();
      if (!str) return '';
      const camel = str
        .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => (chr ? chr.toUpperCase() : ''))
        .replace(/^[A-Z]/, match => match.toLowerCase());
      return camel;
    };

    const toPascalCase = (value = '') => {
      const camel = toCamelCase(value);
      if (!camel) return '';
      return camel.charAt(0).toUpperCase() + camel.slice(1);
    };

    const hasMeaningfulValue = (val) => {
      if (val === null || val === undefined) return false;
      const trimmed = String(val).trim();
      if (!trimmed) return false;
      const lowered = trimmed.toLowerCase();
      return !['no seleccionado', 'ninguno', 'no configurado'].includes(lowered);
    };

    const formatPriceValue = (price) => {
      if (typeof price === 'number') {
        return this.formatPrice(price);
      }
      if (typeof price === 'string' && price.trim()) {
        return price;
      }
      return this.formatPrice(0);
    };

    // Obtener resumen de cada step
    this.stepInstances.forEach(step => {
      // Saltar entradas que todavía no se hayan instanciado
      if (!step || typeof step.getSummary !== 'function') return;

      try {
        const stepSummary = step.getSummary();
        if (!stepSummary) return;

        summary.items.push(stepSummary);

        const summaryId = stepSummary.id || stepSummary.key || stepSummary.label;
        if (!summaryId) return;

        const camelKey = toCamelCase(summaryId);
        if (!camelKey) return;

        const pascalKey = toPascalCase(summaryId);
        const formattedPrice = formatPriceValue(stepSummary.price);
        const valueText = stepSummary.value || '';

  normalized[`${camelKey}Price`] = formattedPrice;
  normalized[`${camelKey}Name`] = valueText;
  normalized[`has${pascalKey}`] = hasMeaningfulValue(valueText) || formattedPrice !== this.formatPrice(0);
      } catch (e) {
        // No queremos que un step defectuoso rompa todo el footer
        console.warn('⚠️ Error obteniendo resumen de step:', e);
      }
    });

    // Si hay magnificación, adjuntarla al item 'Tipo de Cristal' si existe
    try {
      if (this.configuration && this.configuration.magnification) {
        const mag = String(this.configuration.magnification);
        const lensItem = summary.items.find(it => it.label && it.label.toLowerCase().includes('tipo'));
        if (lensItem) {
          lensItem.value = `${lensItem.value} (${mag})`;
          const lensId = lensItem.id || lensItem.key || 'lens-type';
          const camelKey = toCamelCase(lensId || 'lens-type');
          if (camelKey) {
            normalized[`${camelKey}Name`] = lensItem.value;
          }
        }
      }
    } catch (e) {}

    return normalized;
  }

  getFooterSummaryLegacy() {
    const lensTypeData = this.getSelectedLensTypeData();
    const thicknessData = this.getSelectedThicknessData();
    const treatmentsData = this.getSelectedTreatmentsData();
    
    return {
      basePrice: this.formatPrice(this.basePrice / 100),
      lensTypePrice: this.formatPrice(lensTypeData.price),
      lensTypeName: (this.configuration && this.configuration.magnification) ? `${lensTypeData.name} (${String(this.configuration.magnification)})` : lensTypeData.name,
      thicknessPrice: this.formatPrice(thicknessData.price),
      thicknessName: thicknessData.name,
      treatmentsPrice: this.formatPrice(treatmentsData.price),
      treatmentsName: treatmentsData.name,
      totalPrice: this.formatPrice((this.basePrice + (this.lensPrice * 100)) / 100),
      hasLensType: !!this.configuration?.lensType,
      hasThickness: !!this.configuration?.thickness,
      hasTreatments: !!(this.configuration?.treatments && this.configuration.treatments.length > 0)
    };
  }

  getSelectedLensTypeData() {
    const selectedLensType = this.configuration?.lensType;
    if (selectedLensType && this.config.lensTypes) {
      // this.config.lensTypes es un objeto, no un array
      const lensType = this.config.lensTypes[selectedLensType];
      return lensType ? { 
        price: lensType.price || 0, 
        name: lensType.name || lensType.title || selectedLensType 
      } : { price: 0, name: '' };
    }
    return { price: 0, name: '' };
  }

  getSelectedThicknessData() {
    const selectedThickness = this.configuration?.thickness;
    if (selectedThickness && this.config.thickness) {
      // Verificar si thickness es array o objeto
      let thickness = null;
      if (Array.isArray(this.config.thickness)) {
        thickness = this.config.thickness.find(t => t.id === selectedThickness);
      } else {
        thickness = this.config.thickness[selectedThickness];
      }
      
      return thickness ? { 
        price: thickness.price || 0, 
        name: thickness.name || thickness.title || selectedThickness 
      } : { price: 0, name: '' };
    }
    return { price: 0, name: '' };
  }

  getSelectedTreatmentsData() {
    const selectedTreatments = this.configuration?.treatments || [];
    let totalPrice = 0;
    let names = [];
    
    if (this.config.treatments && Array.isArray(selectedTreatments)) {
      selectedTreatments.forEach(treatmentId => {
        let treatment = null;
        if (Array.isArray(this.config.treatments)) {
          treatment = this.config.treatments.find(t => t.id === treatmentId);
        } else {
          treatment = this.config.treatments[treatmentId];
        }
        
        if (treatment) {
          totalPrice += treatment.price || 0;
          names.push(treatment.name || treatment.title || treatmentId);
        }
      });
    }
    
    return { 
      price: totalPrice, 
      name: names.length > 0 ? names.join(', ') : '' 
    };
  }

  // Mantener las funciones originales para compatibilidad
  getSelectedLensTypePrice() {
    return this.getSelectedLensTypeData().price;
  }

  getSelectedThicknessPrice() {
    return this.getSelectedThicknessData().price;
  }

  getSelectedTreatmentsPrice() {
    return this.getSelectedTreatmentsData().price;
  }
}

// Hacer disponible globalmente
window.LensConfiguratorSimple = LensConfiguratorSimple;

// También disponible como CustomLensConfigurator para compatibilidad con el sistema global
window.CustomLensConfigurator = LensConfiguratorSimple;

// LensConfiguratorSimple loaded and exposed globally silently